// Import core libraries
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Import our modules
import App from './inc/App';
import Video from './inc/Video';
//import Store from './inc/Store';
import Menu from './inc/Menu';
import Visit from './inc/Visit';
import Keys from './inc/Keys';
import Barba from './inc/Barba';
import Legacy from './inc/Legacy';
import Wines from './inc/Wines';
import Home from './inc/Home';
import Belong from './inc/Belong';
import CustomExp from './inc/CustomExp';
import Virtual from './inc/Virtual';
import Commerce7 from './inc/Commerce7';
import Shop_C7 from './inc/Shop_C7';
import PDP_C7 from './inc/PDP_C7';
// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

// Initialize modules when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Initialize core modules
  App.init();
  Menu.init();
  Video.init();
  Keys.init();
  Commerce7.init();
  Shop_C7.init();
  PDP_C7.init();
  // Initialize feature-specific modules that don't depend on Barba
  Wines.init();
  Home.init();
  Virtual.init();

  // Initialize Visit if we're on a visit page
  // This ensures it works even if Barba fails to initialize properly
  const container =
    document.querySelector('.barba-container') ||
    document.querySelector('[data-barba="container"]');
  if (container) {
    const namespace =
      container.getAttribute('data-namespace') || container.getAttribute('data-barba-namespace');

    if (namespace === 'visit') {
      console.log('Visit page detected, initializing Visit module');
      setTimeout(() => {
        Visit.init();

        // Initialize scroll animations if not mobile
        if (!App.isMobile()) {
          setTimeout(() => {
            Visit.initScrollAnimations();
          }, 500);
        }
      }, 250);
    } else if (namespace === 'belong') {
      console.log('Belong page detected, initializing Belong module');
      setTimeout(() => {
        Belong.init();

        // Initialize scroll animations if not mobile
        if (!App.isMobile()) {
          setTimeout(() => {
            Belong.initScrollAnimations();
          }, 500);
        }
      }, 250);
    } else if (namespace === 'wines') {
      console.log('Wines page detected, initializing Wines module');
      setTimeout(() => {
        Wines.init();

        // Initialize scroll animations if not mobile
        if (!App.isMobile()) {
          setTimeout(() => {
            Wines.initScrollAnimations();
          }, 500);
        }
      }, 250);
    } else if (namespace === 'custom-experience') {
      console.log('Custom Experience page detected, initializing CustomExp module');
      setTimeout(() => {
        CustomExp.init();
        console.log('CustomExp initialized outside Barba.js lifecycle');
      }, 250);
    } else if (namespace === 'commerce7') {
      console.log('Commerce7 page detected, initializing Commerce7 module');
      setTimeout(() => {
        Commerce7.init();
      }, 250);
    } else if (namespace === 'legacy') {
      console.log('Legacy page detected, initializing Legacy module');
      setTimeout(() => {
        Legacy.init();
        // Initialize scroll animations if not mobile
        if (!App.isMobile()) {
          setTimeout(() => {
            Legacy.initScrollAnimations();
          }, 500);
        }
      }, 250);
    }
  }

  // Setup direct navigation for panel menu instead of Barba.js
  jQuery('.panel-anchor').on('click', function (e) {
    const href = jQuery(this).attr('href');
    if (href) {
      // If on a primary page, use the curtain animation
      if (Menu.primaryPages.includes(App.getURLPath()) || App.getURLPath() === '/') {
        e.preventDefault();

        // Close menu if open
        if (Menu.menuOpen) {
          Menu.menuOpen = false;
          Menu.removeSideScroll();
          App.enableScroll();
          Menu.panelSetOpen();
          Menu.menuTL.progress(1, false);
          Menu.menuTL.timeScale(1.5).reverse();

          // Use curtain animation then navigate
          App.curtainBottomToTop();
          setTimeout(() => {
            window.location.href = href;
          }, 800);
        } else {
          window.location.href = href;
        }
      } else {
        // Standard navigation for non-primary pages
        window.location.href = href;
      }
    }
  });

  // Barba is now disabled - we don't initialize it
  // Barba.init();
  console.log('Barba.js initialization skipped due to conflicts with Commerce7');
});

// Initialize modules that require full page load
window.addEventListener('load', () => {
  // Add visible class to body
  document.body.classList.add('visible');

  // Initialize Store functionality
  //Store.init();

  // Check for sliders that might need reinitializing
  const container =
    document.querySelector('.barba-container') ||
    document.querySelector('[data-barba="container"]');
  if (container) {
    const namespace =
      container.getAttribute('data-namespace') || container.getAttribute('data-barba-namespace');

    if (
      namespace === 'custom-experience' &&
      document.querySelectorAll('.custom-exp-virtual-slider').length
    ) {
      console.log('Reinitializing CustomExp sliders on page load');
      setTimeout(() => {
        CustomExp.customExSlider();
      }, 500);
    }
  }
});

// Make modules available globally for backward compatibility
window.App = App;
window.Video = Video;
//window.Store = Store;
window.Menu = Menu;
window.Visit = Visit;
window.Keys = Keys;
window.Trans = Barba;
window.Legacy = Legacy;
window.Wines = Wines;
window.Home = Home;
window.Belong = Belong;
window.CustomExp = CustomExp;
window.Virtual = Virtual;
window.Commerce7 = Commerce7;
